var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListExameComum',{attrs:{"data":_vm.data}}),_c('ListExameAltoCusto',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }